var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M76 56C81.96 50.16 88 43.16 88 34C88 28.1652 85.6822 22.5695 81.5564 18.4437C77.4306 14.3179 71.8348 12 66 12C58.96 12 54 14 48 20C42 14 37.04 12 30 12C24.1652 12 18.5695 14.3179 14.4437 18.4437C10.3179 22.5695 8 28.1652 8 34C8 43.2 14 50.2 20 56L48 84L76 56Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Heart.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
